<template>
    <div class="pb-0 group-title-wrapper" v-show="!showSocialPlanDetails">
        <div class="group-title">
            <div class="group-title col-md-6">
                <h1 class="mb-0 exclude-outside-click project-title edit-d-title cursor-pointer" v-show="!editTitle" @click="activateTitleField">{{
                    deliverableDetail.title }} </h1>
                <textarea v-click-outside="clickOutsideTitle" ref="editTitleRef" v-show="editTitle"
                    v-model="deliverableDetail.title" type="text" :placeholder="getDeliverableTitlePlaceholder"
                    class="form-control mb-3 title-field exclude-outside-click h1" @change="updateDeliverableTitle"
                    @blur="editTitle = false;"></textarea>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Format from "../../utility/Format";

export default {
    props: [
        'deliverableDetail',
        'deliverableTypes',
        'showSocialPlanDetails',
        'namespace',
    ],

    data() {
        return {
            editTitle: false,
            Format,
        };
    },
    computed: {
        ...mapState({
            state(state) {
                return state[this.namespace]
            },
        }),
        ...mapGetters([
            "getDeliverableTemplateSlug",
        ]),
        _() {
            return _;
        },
        getDeliverableTitlePlaceholder() {
            if (this.deliverableDetail) {
                const deliverableTypeObj = this.deliverableTypes.find(x => x.typeId == this.deliverableDetail.deliverable_template_id);
                const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(this.deliverableDetail.deliverable_template_id));
	    	    if (deliverableTemplateSlug == "media-call") {
                    return "Media call title...";
                } else {
                    if (deliverableTypeObj) {
                        return deliverableTypeObj.name + " title...";
                    } else {
                        return "Deliverable title...";
                    }
                }
            }
        },
    },
    methods: {
        ...mapActions({
            updateSocialSeriesFieldValue(dispatch, payload) {
                return dispatch(this.namespace + 'updateSocialSeriesFieldValue', payload)
            },
        }),
        activateTitleField() {
            this.editTitle = true;
            let that = this;
            setTimeout(() => {
                that.$refs.editTitleRef.select();
            }, 100);
        },
        clickOutsideTitle() {
            this.editTitle = false;
        },
        updateDeliverableTitle() {
            this.deliverableDetail.title = Format.replaceLineBreaks(this.deliverableDetail.title, " ");
            this.$store.dispatch(this.namespace + "updateFieldValue", this.deliverableDetail);
        },

    },
}
</script>
<style scoped>

.group-title-wrapper {
    width: 100%;
}

h1 {
    font-size: 22px;
}

h1.edit-d-title::after {
    background: transparent;
    right: -40px;
    color: #cbd3cb;
}

textarea.title-field {
    font-size: 2.25rem;
}
</style>